export default __webpack_public_path__ + "static/media/agenda.5aac792a.svg";